
(function() {

    'use strict';

    angular.module('iplusjs.config', [])
        .provider('AppConfig', AppConfigProvider);

    function AppConfigProvider() {
        function toBoolean(value, defaultVal) {
            return value === 'true' ? true :
                value === 'false' ? false : (defaultVal || false);
        }

        var config = {
            APP: {
                debugInfoEnabled: toBoolean('false'),
                regexAHrefSanitizationTrustedUrlList: /^\s*(https?|mailto|blob|data|tel):/,
                releaseDir: 'RELEASE-10.17.1-1792070795108',
                releaseId: '10.17.1-1792070795108',
                auslaendischeIbanErlaubt: true,
                telefon: '0711 1695-1400',
                telefonDirektion: '0711 1695-1400',
                telefonRisikopruefung: '',
                telefonFirmenkunde: '0711 1695-1422' || '0711 1695-1400',
                telefonKundenservice: '0711 1695-1500',
                defaultCssClassMainWidthContainer: 'cssClassMainWidthContainerMedium' || 'cssClassMainWidthContainer',
                cssClassMainWidthContainer: 'xlarge-6 large-8 medium-10 print-12 small-centered',
                cssClassMainWidthContainerSmall: 'xlarge-4 large-6 medium-7 print-12 small-centered',
                cssClassMainWidthContainerMedium: 'xlarge-8 large-9 medium-11 print-12 small-centered',
                cssClassMainWidthContainerLarge: 'xlarge-9 large-11 medium-12 print-12 small-centered',
                testsiegelFilter: '{"3":{"Produkt":"Motorrad"},"14":{"Produkt":"LKRoller"},"24":{"Produkt":"LKRad"},"31":{"Produkt":"Quad"},"112":{"Produkt":"KFZ"},"127":{"Produkt":"Womo"},"451":{"Produkt":"ZM-G"},"452":{"Produkt":"ZM-S"},"501":{"Produkt":"AH"},"541":{"Produkt":"WoWa"}}' !== '' ? JSON.parse('{"3":{"Produkt":"Motorrad"},"14":{"Produkt":"LKRoller"},"24":{"Produkt":"LKRad"},"31":{"Produkt":"Quad"},"112":{"Produkt":"KFZ"},"127":{"Produkt":"Womo"},"451":{"Produkt":"ZM-G"},"452":{"Produkt":"ZM-S"},"501":{"Produkt":"AH"},"541":{"Produkt":"WoWa"}}') : null, // eslint-disable-line no-constant-condition
                compactModeNavigation: toBoolean('true', false),
                compactModeMediaQueryBreakpoint: 'small',
                webMcpTarifberechnung: null,
                webMcpSpeichern: null,
                stepsSizeBreakpoint: parseInt('4' || 3, 10),
                reloadIntegrationParamsOnStart: toBoolean(null, false),
                vorstand: {
                    mandant1: [
                        'Dr. Klaus Brachmann (Vorsitzender)',
                        'Anja Emde',
                        'Hartmut Schöch'
                    ],
                    mandant2: [
                        'Dr. Klaus Brachmann (Vorsitzender)',
                        'Anja Emde',
                        'Hartmut Schöch'
                    ],
                    mandant5: [
                        'Dr. Klaus Brachmann (Vorsitzender)',
                        'Anja Emde',
                        'Hartmut Schöch'
                    ]
                },
                postanschrift: 'WGV-Versicherung AG<br>Tübinger Str. 55<br>70178 Stuttgart',
                kontaktadressen: null,
                unternehmenName: null || 'WGV Versicherung',
                printAbschlussType: 'REPORT',
                tracking: {
                    wgv: {
                        trackingEnabled: toBoolean('true'),
                        accountId: 'Hhdkl3',
                        startpage: '/einstieg',
                        area: 'ICISPlus-Angebot/KFZ',
                        url: null || undefined,
                        jsUrl: '//www.wgv.de/app/wt.js' || '//www.wgv.de/app/wt.js',
                    },
                    etracker: {
                        trackingEnabled: toBoolean('true'),
                        accountId: 'Dsx9S9',
                        startpage: '/einstieg/',
                        areas: 'ICISPlus-Angebot/KFZ',
                        pageTrackPrefix: 'ICISPlus-Angebot_KFZ-',
                        eventTrackPrefix: 'ICISPlus-Angebot_KFZ-',
                        eventTrackDefaultTags: 'Angebot'
                    },
                    hurra: {
                        trackingEnabled: toBoolean('true'),
                        customerId: '926',
                        domain: null || 'https://www.wgv.de'
                    }
                },
                wkzUrlMapping: {
                    3: 'motorrad',
                    14: 'leichtkraftroller',
                    24: 'leichtkraftrad',
                    30: 'trike',
                    31: 'quad',
                    112: 'auto',
                    127: 'wohnmobil',
                    251: 'lieferwagen',
                    451: 'landw-zugmaschinen-gruen-kennz',
                    452: 'landw-zugmaschinen-schwarz-kennz',
                    501: 'anhaenger',
                    541: 'wohnwagen'
                },
                debounce: {
                    fast: 500,
                    normal: 750,
                    slow: 1000,
                    pdfReport: 1000
                },
                upload: {
                    multiple: true, // dürfen mehrere Dateien gleichzeitig hochgeladen werden?
                    fileTypes: [ // Erlaubte MimeTypes
                        'image/jpeg',
                        '.jpg',
                        'application/pdf',
                        'image/tiff',
                        '.tif'
                    ].join(','),
                    icap: {
                        regexDetectRules: {
                            status: /^403$/,
                            statusText: /Forbidden by proxy/i
                        }
                    }
                },
                logging: {
                    debugEnabled: toBoolean('false'),
                    logEnabled: toBoolean('false'),
                    infoEnabled: toBoolean('false'),
                    errorEnabled: toBoolean('true'),
                    remoteLogging: {
                        enabled: toBoolean('true'),
                        url: '../../wgv/eicis/extj_session.log_error',
                        httpMethod: 'POST',
                        httpHeaderContentType: 'application/x-www-form-urlencoded',
                        customExceptionHandlerName: 'ExceptionHandlerEicisService',
                        stacktraceRegex: /https:\/\/www[2-4]?\.wgv\.de/g
                    }
                },
                urls: {
                    root: '',
                    dms: '__dms',
                    homepage: 'https://www.wgv.de',
                    kundenportalInfo: 'https://www.wgv.de/meinewgv/',
                    kundenportal: 'https://www.wgv.de/app/pks2020',
                    kundenportalStartseite: 'https://www.wgv.de/app/pks2020/menu',
                    kundenportalAngebote: 'https://www.wgv.de/app/pks2020/angebote',
                    kundenportalVertraege: 'https://www.wgv.de/app/pks2020/vertraege',
                    kundenportalVertragDetails: 'https://www.wgv.de/app/pks2020/vertraege/vertrag-details/{0}',
                    kundenportalPostfach: 'https://www.wgv.de/app/pks2020/postfach',
                    kundenportalVertragDetailsDeepLink: '/app/pks2020/vertraege/vertrag-details/{0}',
                    produkt: 'auto-mobilitaet/', // eslint-disable-line no-dupe-keys
                    kontakt: 'https://www.wgv.de/kundenservice/kontakt/',
                    fortsetzen: 'https://www.wgv.de/abschluss?an={0}&at={1}',
                    datenschutzerklaerung: 'https://www.wgv.de/datenschutz/#a33',
                    datenschutzhinweise: 'https://www.wgv.de/datenschutz/',
                    uwgvorteile: 'https://www.wgv.de/datenschutz/beispiele.html',
                    wartungsarbeitenImage: 'https://www.wgv.de/media/pictures/wartungsarbeiten.jpg',
                    appStoreLinks: 'https://www.wgv.de/kundenservice/wgv-app/',
                    thgPraemie: 'https://www.wgv.de/thg-quote/',
                    testsiegel: 'siegel_tarifrechner.json',
                    ekomisiegel: {
                        bronze: 'https://www.wgv.de/media/pictures/ekomi/zerti_bronze_new.png',
                        silber: 'https://www.wgv.de/media/pictures/ekomi/zerti_silber_new.png',
                        gold: 'https://www.wgv.de/media/pictures/ekomi/zerti_gold_new.png'
                    },
                    ekomisiegelInfo: 'https://www.wgv.de/eKomi.php',
                },
                links: {
                    
                    
                    vertragsunterlagen: '{0}/docs/vertragsunterlagen/{1}.pdf'

                },
                alertStateActions: {
                    NUR_ABBUCHER_MOEGLICH: 'rechner.persoenlichedaten'
                },
                pdfviewer: {
                    url: '../iplusjs/assets/pdfjs/web/viewer.html',
                    options: [
                        'pagemode=thumbs',
                        'zoom=page-fit'
                    ]
                },
                pdfModus: 'pdfjs' || 'native' // 'pdfjs' | 'native‘ | 'dynamic'
            },
            INTEGRATION: {
                url: '../../wgv/eicis',
                checkSizeFunction: 'pruefeIframeSize',
                keepAliveInterval: parseInt('5' || 2, 10), // Minutes
                messageOrigins: ('https://www.wgv.de#https://wgv.de' || '').split('#'), // Empfang von Nachrichten (von welchen Origins sind die Nachrichten erlaubt)
                postMessageOrigin: 'https://www.wgv.de', // Senden von Nachrichten (welche Origin darf die Nachrichten empfangen)
                frameBusterEnabled: toBoolean(null, true),
                frameBusterHostnameExcludes: ('www.wgv.de#wgv.de#pks.wgv.de' || '').split('#'),
                loginPage: '/meinewgv/login/',
                permissionsToCheck: [  // with checkPermission Service
                    'ANG_PKS_REGISTRIEREN'
                ],
                redirectUrlAfterPksLogin: '/wgv/eicis/wwwang.angebot?p_frames=FRAM&p_ang_typ=KFZ_IP',
                services: {
                    keepAlive: '../../wgv/eicis/extj_session.check_active?p_sid={0}&p_time={1}',
                    checkPermission: '../../wgv/eicis/extj_session.check_active?p_sid={0}&p_recht={1}&p_time={2}',
                    createAnonymSession: '../../wgv/eicis/vmtextern.service_checksesssionanonym',
                    createVouchers: '../../wgv/eicis/extj_ang.Ang_Gutschein',
                    checkPasswordSecurity: '../../wgv/eicis/extj_benutzer.service_check_passwort?p_sid={0}',
                    checkPasswordSecurityWithoutSid: '../../wgv/eicis/extj_benutzer.service_check_passwort',
                    kundenportalRegister: '../../wgv/eicis/extj_benutzer.registrieren?p_sid={0}',
                    kundenportalLogin: '../../wgv/eicis/extj_session.login_user'
                }
            },
            PAYMENT_FRAME: {
                messageOrigins: (null || '').split('#'), // Empfang von Nachrichten (von welchen Origins sind die Nachrichten erlaubt)
                postMessageOrigin: null // Senden von Nachrichten (welche Origin darf die Nachrichten empfangen)
            },
            PAYMENT_OVERLAY: {
                messageOrigins: (null || '').split('#'), // Empfang von Nachrichten (von welchen Origins sind die Nachrichten erlaubt)
                supportedBrowsers: {
                    msie: '11',
                    firefox: '10',
                    chrome: '27',
                    safari: '7',
                    opera: '16',
                    msedge: '12',
                    samsungBrowser: '2.1',
                    silk: '59.3',
                    ucbrowser: '10.0.0.488',
                    vivaldi: '1.91'
                }
            },
            PAYMENT_CONFIG: {
                apiKey: (null || '')
            },

            PAYMENT: {
                loadingLogo: {
                    url: '../iplusjs/assets/img/wgv_logo.svg',
                    cssClass: 'wgv-logo',
                    altAttr: 'WGV Versicherung'
                }
            },
            API: {
                url: '../../ippa',
                anonymUsername: 'public',
                anonymPassword: 'b8&3[&CK#Q6uXwwp8a',
                tokenLoginPrefix: 'TOKEN_LOGIN_',
                regexJsonResponsePrefix: /(for\(;;\);)(.*)/,
                dateFormat: 'YYYY-MM-DD',
                timeout: parseInt('60000' || 60000, 10),
                timeoutLong: parseInt('120000' || 120000, 10),
                services: {
                    login: '../../ippa/j_spring_security_check',
                    angTaetigkeitsschluessel: '../../ippa/secure/angebot/public/taetigkeitsschluessel',
                    angSepaMandat: '../../ippa/secure/angebot/{0}/{1}/sepa/mandat/{2}',
                    angAngebotDruckVorschau: '../../ippa/secure/angebot/angebotDruckVorschau/{0}/{1}',
                    angAngebotDruckEmail: '../../ippa/secure/angebot/angebotDruckEmail/{0}/{1}',
                    angAngebotDruckPost: '../../ippa/secure/angebot/angebotDruckPost/{0}/{1}',
                    angGetAngTg: '../../ippa/secure/angebot/tg/own/{0}',
                    angGetAngTgWithToken: '../../ippa/secure/angebot/tg/{0}/{1}',
                    angKopieren: '../../ippa/secure/angebot/{0}/{1}/copy',
                    angEKomi: '../../ippa/secure/angebot/{0}/{1}/ekomi',
                    angDateiAnhangMultipart: '../../ippa/secure/angebot/dateimultipart/{0}/{1}',
                    angGetDateiAnhang: '../../ippa/secure/angebot/anhang/{0}/{1}/{2}',
                    angDeleteDateiAnhang: '../../ippa/secure/angebot/{0}/{1}/entferne/anhang/{2}',
                    angAvb: '../../ippa/secure/angebot/avb/{0}/{1}',
                    angAntragUebersichtDrucken: '../../ippa/secure/angebot/Kfz201701/kfz/angebotDruckKfzZusammenfassung/{0}/{1}',
                    angNeuMitAntragsteller: '../../ippa/secure/angebot/Kfz201701/public/kfz/neuMitAntragsteller/{0}/{1}',
                    

                    angTarifgeneration: '../../ippa/secure/angebot/public/kfz/tarifgeneration',
                    angRefresh: '../../ippa/secure/angebot/{0}/public/kfz/refresh',
                    angBerechnen: '../../ippa/secure/angebot/{0}/public/kfz/berechnen',
                    angSpeichern: '../../ippa/secure/angebot/{0}/public/kfz/speichern',
                    angErzeugeVertrag: '../../ippa/secure/angebot/{0}/public/kfz/erzeugevertrag',
                    angValidiere: '../../ippa/secure/angebot/{0}/public/kfz/validiere/stufe/{1}',
                    angStatusAntrag: '../../ippa/secure/angebot/{0}/public/kfz/statusantrag/{1}/{2}',
                    angAntragDruckVorschau: '../../ippa/secure/angebot/{0}/public/kfz/antragDruck/{1}/{2}',
                    angAntragDruckEmail: '../../ippa/secure/angebot/{0}/public/kfz/antragDruckEmail/{1}/{2}',
                    angAntragDruckPost: '../../ippa/secure/angebot/{0}/public/kfz/antragDruckPost/{1}/{2}',

                    

                    angLoeschen: '../../ippa/secure/angebot/{0}/{1}/{2}',
                    angTelefonnummerValidieren: '../../ippa/secure/angebot/rufnummernvalidierung',
                    swPrefix: '../../ippa/secure/sw/',
                    angNeu: '../../ippa/secure/angebot/{0}/public/kfz/neu/wkz/{1}', // eslint-disable-line no-dupe-keys
                    angPreCheck: '../../ippa/secure/angebot/{0}/public/kfz/precheck',
                    angKfzSfkKhKv: '../../ippa/secure/angebot/{0}/kfz/schadenfreiheitsklassenhaftpflichtundvollkasko/{1}/wkz/{2}/produkt/91',
                    angKfzSfkSondereinstufungZweitwagenFlags: '../../ippa/secure/angebot/{0}/public/kfz/schadenfreiheitsklassenhaftpflichtundvollkasko/zweitwagenregelung',
                    angKfzFzgBezeichnungNeuwert: '../../ippa/secure/angebot/{0}/kfz/fahrzeugdaten/hsn/{1}/tsn/{2}',
                    angKfzZulassungsbezirke: '../../ippa/secure/angebot/{0}/kfz/zuordnungplzzbn/{1}',
                    angKfzTarifumstellung: '../../ippa/secure/angebot/{0}/public/kfz/tarifumstellung',
                    angKfzFzgSucheKonzern: '../../ippa/secure/angebot/{0}/public/kfz/suche/konzern',
                    angKfzFzgSucheBaureihe: '../../ippa/secure/angebot/{0}/public/kfz/suche/baureihe/konzern/{1}',
                    angKfzFzgSucheKraftstoff: '../../ippa/secure/angebot/{0}/public/kfz/suche/kraftstoff/konzern/{1}/baureihe/{2}',
                    angKfzFzgSucheKategorie: '../../ippa/secure/angebot/{0}/public/kfz/suche/kategorie/konzern/{1}/baureihe/{2}/kraftstoff/{3}',
                    angKfzFzgSucheTueren: '../../ippa/secure/angebot/{0}/public/kfz/suche/tueren/konzern/{1}/baureihe/{2}/kraftstoff/{3}/kategorie/{4}',
                    angKfzFzgSucheLeistung: '../../ippa/secure/angebot/{0}/public/kfz/suche/leistung/konzern/{1}/baureihe/{2}/kraftstoff/{3}/kategorie/{4}/tueren/{5}',
                    angKfzFzgSucheTypen: '../../ippa/secure/angebot/{0}/public/kfz/suche/typen/konzern/{1}/baureihe/{2}/kraftstoff/{3}/kategorie/{4}/tueren/{5}/leistung/{6}',
                    angKfzTB28Formular: '../../ippa/secure/angebot/{0}/kfz/{1}/{2}/formularTb28',
                    angKfzRueckwirkenderVertragsbeginnFormular: '../../ippa/secure/angebot/{0}/kfz/{1}/{2}/formularRueckwVerBeginn',
                    angKfzCheckOnlinezulassung: '../../ippa/secure/angebot/{0}/kfz/{1}/{2}/checkOnlinezulassung/{3}',
                    angKfzOnlinezulassungDrucken: '../../ippa/secure/angebot/{0}/kfz/{1}/{2}/druckOnlinezulassung/{3}',
                    angKfzSwVorverdauerPrefix: '../../ippa/secure/angebot/Kfz201701/kfz/',

                    

                    

                    wertermittlungBerechnen: '../../ippa/secure/wertermittlung/public/wertermittlungsbogen/berechnen',
                    wertermittlungDurchfuehren: '../../ippa/secure/wertermittlung/public/wertermittlungsbogen/durchfuehren',
                    wertermittlungLaden: '../../ippa/secure/wertermittlung/public/wertermittlungsbogen/laden',

                    kontoKtoNr: '../../ippa/secure/kontodaten/blz/{0}/konto/{1}/land/{2}',
                    kontoIban: '../../ippa/secure/kontodaten/iban/{0}',
                    adresseChecker: '../../ippa/secure/adresse/check',
                    adressen: '../../ippa/secure/partner/adressen',
                    vertragPrdChecker: '../../ippa/secure/vertrag/exists/{0}/{1}',
                    vertragHuWChecker: '../../ippa/secure/vertrag/isHuWVertrag/{0}',
                    vertragTierSchutzbriefChecker: '../../ippa/secure/vertrag/isTierSchutzbriefVertrag/{0}',
                    versicherungsbestaetigungChecker: '../../ippa/secure/versicherungsbestaetigung/kurzzeitkennzeichen/{0}',
                    fahrzeugsucheKomfort: '../../ippa/secure/fahrzeugsuche/komfortsuche',
                    fahrzeugsucheDetail: '../../ippa/secure/fahrzeugsuche/detailsuche',
                    uwgEinwilligung: '../../ippa/secure/uwg/check/{0}/{1}',

                    adresseSearch:  'https://www.wgv.de/postService/post/V1/postProject_DEU/postProfile-FC',
                    checkMaintenance: '/errordocs/status.json'
                }
            },
            ANGEBOT: {
                angebotstyp: 'KFZ',
                tarifkuerzel: 'Kfz201701',
                tarifbeginn: '2017-01-01',
                tarifauskunftsdatumType: 'tarifauskunftsdatum' || 'tarifauskunftsdatum',
                arbeitgeberBerufAbfrage: toBoolean('false', true),
                disableTarifgenerationHandling: toBoolean(null, false),
                beitragsrueckerstattungHinweis: toBoolean('false'),
                beratungsverzichtHinweis: toBoolean('true'),
                
                plzAntragstellerEingabeImAngebot: toBoolean('true'),
                geburtsdatumAntragstellerEingabeImAngebot: toBoolean('true', false),
                privatkundeEingabeImAngebot: toBoolean('true'),
                produktBezeichnung: 'Kraftfahrtversicherung',
                produktSubText: 'Bester Schutz für Ihr Fahrzeug',
                
                vorversicherungVersion: 'EINE_VORVERSICHERUNG',
                flexibleAngebotVersion: null,
                vertragHauptfaelligkeit: '01.01.' || '01.01.',
                showHinweisAbweichenderPraemienzahlerNichtErlaubt: toBoolean('false'),
                waitHelperUrl: '../helper_wait/wait',
                abschlussType: 'VERTRAG',
                druckwege: JSON.parse('{"vorschau":{"wert":"vorschau","bezeichnung":"als PDF"},"email":{"wert":"email","bezeichnung":"per E-Mail"}}'),
                druckwegVorschauDirektdruck: toBoolean(null, true),
                druckwegEmailDirektdruck: toBoolean(null, true),
                versicherungsbeginnRegel: null,
                tarifartEmpfehlung: 'S',
                defaultMoeglicheTarifarten: 'B#S',
                defaultMandant: null || '2',
                vouchers: {
                    POLO: toBoolean(null, true)
                },
                blaulichtVorhanden: toBoolean('true', false),
                paymentProvider: {
                    redirect: {
                        urlPrefix: null,
                        resultUrlSuccess: 'payment/{0}?an={1}&at={2}&ps=SUCCESS',
                        resultUrlFailure: 'payment/{0}?an={1}&at={2}&ps=FAILURE'
                    },
                    popup: {
                        urlPrefix: null,
                        resultUrlSuccess: 'result/{0}?an={1}&at={2}&p={3}&ps=SUCCESS',
                        resultUrlFailure: 'result/{0}?an={1}&at={2}&p={3}&ps=FAILURE'
                    }
                },
                angebotsarten: {
                    RUECKGEWINNUNG: 'RUECKGEWINNUNG',
                    UMSCHREIBUNG: 'UMSCHREIBUNG'
                },
                inkassoarten: [
                    'Abbucher',
                    'Rechnung'
                ],
                zahlweiseText: {
                    47: 'Einmalig',
                    48: 'pro Monat',
                    49: 'pro Vierteljahr',
                    50: 'pro Halbjahr',
                    51: 'pro Jahr'
                },
                clearingStatus: [
                    'CHECK',
                    'VORBEHALT',
                    'WARTEN_VB_RUECKLAUF',
                    'WARTEN_ABMELDUNG',
                    'ERROR',
                    'NACHBEARBEITEN',
                    'VERTRAG_ANGELEGT_SCHWEBE'
                ],

                angestellterBevorzugteArbeitgeber: [
                    '5', // Banken und Kreditinstitute (privat)
                    '6', // Bausparkassen (privat)
                    '7', // Versicherungen (privat)
                    '8', // Investmentgesellschaften (privat)
                    '9', // TÜV, DEKRA und GTÜ
                    '10', // Schulen (Privat)
                    '11', // Krankenhäuser (Privat)
                    '13', // Architekturbüro
                    '16', // Rechtsanwaltskanzlei
                    '17', // Steuerberatungsbüro
                    '23' // Postbank
                ],

                selbststaendigerBevorzugteBerufszweige: [
                    '8', // Investmentgesellschaften (privat)
                    '13', // Architekturbüro
                    '14', // Fahrschule
                    '15', // Notariat (außerhalb Baden-Württemberg und Bayern)
                    '18', // Unternehmensberatung
                    '19' // Wirtschaftsprüfungsgesellschaft
                ],

                apiNachrichtenFilter: [
                    'PKS_NEUREGISTRIERUNG_MOEGLICH'
                ],
                vermittlernummern: {
                    POLO: '100077'
                },
                risikoleben: {
                    maxAnzahlBeszugsrechtTodesfallPartner: 4,
                    maxAnzahlErklaerungGeldwaeschePartner: 4,
                    compassRisikoanalyseEnabled: toBoolean(null, true)
                },
                kfz: {
                    defaults: {
                        jaehrlicheFahrleistungSaison: 10000
                    },
                    subTitle: {
                        3: 'Bester Schutz für Ihr Kraftrad / Ihren Kraftroller',
                        14: 'Bester Schutz für Ihren Leichtkraftroller (bis 11 KW, 50 - 125 ccm)',
                        24: 'Bester Schutz für Ihr Leichtkraftrad (bis 11 KW, 50 - 125 ccm)',
                        30: 'Bester Schutz für Ihr Trike (3-rädriges Motorrad)',
                        31: 'Bester Schutz für Ihr Quad (4-rädriges Motorrad)',
                        112: 'Bester Schutz für Ihren Personenkraftwagen',
                        127: 'Bester Schutz für Ihr Campingfahrzeug / Wohnmobil',
                        251: 'Bester Schutz für Ihren Lkw (bis 3,5 t Gesamtmasse)',
                        451: 'Bester Schutz für Ihre landw. Zugmaschine (grünes Kennzeichen)',
                        452: 'Bester Schutz für Ihre landw. Zugmaschine (schwarzes Kennzeichen)',
                        501: 'Bester Schutz für Ihren Anhänger (Werknah- und Privatverkehr)',
                        541: 'Bester Schutz für Ihren Wohnwagenanhänger'
                    },
                    wkz: {
                        PKW: '112',
                        MOTORRAD: '3',
                        CAMPINGKRAFTWAGEN_WOHNMOBILE: '127',
                        LEICHTKRAFTROLLER_BIS_80_CCM: '12',
                        LEICHTKRAFTROLLER_50_BIS_125_CCM: '14',
                        LEICHTKRAFTRAEDER_50_BIS_135_CCM: '24',
                        TRIKE_DREIRAEDRIGES_MOTORRAD: '30',
                        QUAD_VIERRAEDRIGES_MOTORRAD: '31',
                        WOHNWAGENANHAENGER: '541',
                        LKW_BIS_3_5T_NUTZLAST: '251',
                        LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_GRÜNEM_KENNZEICHEN: '451',
                        LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_SCHWARZEM_KENNZEICHEN: '452',
                        ANHAENGER_WERKNAH_UND_PRIVATVERKEHR: '501'
                    },
                    gevo: {
                        KFZ_NEUGESCHAEFT: 'GevoIcisPlusKfzNeugeschaeft', // 1
                        KFZ_TRANSFERBESTIMMUNG_28: 'GevoIcisPlusKfzTransferbestimmung28', // 1b
                        KFZ_ZUSAETZLICHER_VERTRAG: 'GevoIcisPlusKfzZusaetzlicherVertrag', // 2
                        KFZ_VERSICHERERWECHSEL_SELBES_FZG: 'GevoIcisPlusVersichererwechselSelbesKfz', // 3
                        KFZ_FAHRZEUGWECHSEL: 'GevoIcisPlusKfzFahrzeugwechsel', // 4
                        KFZ_VERSICHERERWECHSEL_NEUES_FZG: 'GevoIcisPlusKfzVersichererwechselNeuesKfz', // 4b
                        KFZ_TARIFUMSTELLUNG: 'GevoIcisPlusKfzTarifumstellung' // 5
                    },
                    sfKlasseSondereinstufungen: {
                        MOPED: ['2'],
                        ZWEITWAGEN: [
                            '1',
                            '2',
                            '3',
                            '4'
                        ],
                        YD: [
                            '2',
                            '4'
                        ]
                    }
                },
                mockAngebotstyp: '',

                pdfNames: {
                    

                    angebot: {
                        name: 'Tarifauskunft-{0}.pdf',
                        bezeichnung: 'Tarifauskunft'
                    },
                    antrag: {
                        name: 'Antrag-{0}.pdf',
                        bezeichnung: 'Antrag'
                    },
                    antragUebersicht: {
                        name: 'Antragsübersicht-{0}.pdf',
                        bezeichnung: 'Antragsübersicht'
                    },
                    onlinezulassung: {
                        name: 'Onlinezulassung-{0}.pdf',
                        bezeichnung: 'Onlinezulassung'
                    },
                    antragZusammenfassung: {
                        name: 'Zusammenfassung-{0}.pdf',
                        bezeichnung: 'Zusammenfassung'
                    }
                },

                links: {
                    tb28Rabattuebertragung: 'https://www.wgv.de/docs/antrag/tb28.pdf',

                    

                    musterrechnung: 'https://www.wgv.de/kundenservice/service/vertrags-und-partnernummer/'
                },

                mgaPrivat: [
                    '61'
                ],

                zahlweisen: {
                    JAEHRLICH: {
                        wert: '51',
                        bezeichnung: 'jährlich'
                    },
                    HALBJAEHRLICH: {
                        wert: '50',
                        bezeichnung: 'halbjährlich'
                    },
                    VIERTELJAEHRLICH: {
                        wert: '49',
                        bezeichnung: 'vierteljährlich'
                    },
                    MONATLICH: {
                        wert: '48',
                        bezeichnung: 'monatlich'
                    },
                    EINMAL: {
                        wert: '47',
                        bezeichnung: 'Einmalbeitrag'
                    }
                },

                status: {
                    ANGEBOT: 'A',
                    GEDRUCKT: 'D',
                    GEDRUCKT_TEILWEISE_AENDERBAR: 'Q',
                    ANTRAG_DRUCK: 'F',
                    ANTRAG_PAYMENT_REQUIRED: 'P',
                    ANTRAG: 'O',
                    ANTRAG_KFZ: 'E',
                    ANTRAG_ABGELEHNT: 'X',
                    VERTRAGSAENDERUNG: 'C',
                    VERTRAGSANLAGE: 'V'
                },

                statusNachDruck: null || 'D',

                tarifarten: {
                    P: 'PLUS',
                    S: 'OPTIMAL',
                    B: 'BASIS'
                },

                antragPruefenAdditionalButtons: [
                
                ]
            },

            MODAL: {
                angebotNichtAenderbar: {
                    buttonOk: toBoolean(null, true)
                },
                neuerTarif: {
                    buttonOk: toBoolean(null, true)
                }
            },

            REITER: {
                antragpruefen: {
                    blockSpaeterFortsetzen: toBoolean(null, true)
                },
                persoenlichedaten: {
                    title: null || 'Persönliche Daten',
                    blockAbweichenderVersicherungsnehmer: toBoolean(null, false)
                },
                abschluss: {
                    blockEkomi: toBoolean(null, true),
                    blockKundenportal: toBoolean(null, true)
                }
            },
            MESSAGES: {
                druckenPopup: 'Die Datei wird in einem neuen Fenster geöffnet. Sie sehen das Fenster nicht? Hier können Sie es wieder öffnen.',
                hinweisFahrzeughalterVnPlzAntragstellerPlzAbweichend: {
                    VN_ANTRAGSTELLER: 'Die Postleitzahl des Fahrzeughalters stimmt nicht mit der Postleitzahl des Antragstellers überein.',
                    ABW_HALTER: 'Die Postleitzahl des Fahrzeughalters in der Tarifauskunft stimmt nicht mit den Angaben im Antrag überein.'
                },
                nachrichtAbschlussEvb: [
                    'Für die Zulassung Ihres Fahrzeugs verwenden Sie bitte die Versicherungsbestätigungs-Nummer:',
                    '<div>',
                    '    <hr class="spacer-small">',
                    '    <div class="row">',
                    '        <div class="columns small-12 text-center" data-ng-class="{\'medium-6\': <%= data.onlinezulassungErlaubt %>}">',
                    '            <strong><%= data.evbNummer %></strong>',
                    '        </div>',
                    '        <div class="columns small-12 text-center" data-ng-if="<%= data.onlinezulassungErlaubt %>" data-ng-class="{\'medium-6\': <%= data.onlinezulassungErlaubt %>}">',
                    '            <strong>',
                    '                <iplusjs-druck-download-link',
                    '                    data-iddl-action="abschlussVm.drucken(\'onlinezulassung\')"',
                    '                    data-iddl-file="abschlussVm.onlinezulassungPdf"',
                    '                    data-iddl-text="hier gleich online zulassen"',
                    '                    data-iddl-title="Onlinezulassung"',
                    '                    data-iddl-css-class="link highlight oil arrow"',
                    '                ></iplusjs-druck-download-link>',
                    '            </strong>',
                    '        </div>',
                    '    </div>',
                    '</div>',
                    'Die Versicherungsbestätigung wird von der Zulassungsbehörde nur bis zum <strong><%= data.evbAbrufbarBis %></strong> akzeptiert.',
                    'Bitte benachrichtigen Sie uns, sollten Sie Ihr Fahrzeug nicht innerhalb dieser Zeit zulassen. Wir stellen dann gerne eine neue Versicherungsbestätigung bereit.'
                ].join(' '),
                angebotDatenNichtAenderbarEvb: 'Einige Angaben in der Tarifauskunft sind nicht mehr änderbar, da die Tarifauskunft mit der eVB-Nummer <strong>{0}</strong> verknüpft ist.',
                hinweisReiterAbschlussAllgemein: 'Wir bedanken uns für Ihren Antrag auf eine {0} und das uns damit erwiesene Vertrauen.',
                hinweisVersicherungsbeginnAnpassungNotwendig: 'Bitte korrigieren Sie den Versicherungsbeginn auf dem Reiter "Allgemeine Daten".<br><a class="link arrow forward oil" data-ui-sref="rechner.allgemein">Versicherungsbeginn anpassen</a>',

                

                hinweisVersicherungsbeginnKopieNotwendig: 'Bitte kopieren Sie die Tarifauskunft für eine neue Berechnung.<br><a href="" class="link arrow forward oil" data-ng-click="angebotVm.kopiereAngebot();">Tarifauskunft kopieren</a>',
                hinweisVersicherungsbeginnNeuesAngebotNotwendig: 'Bitte erstellen Sie eine neue Tarifauskunft.<br><a href="" class="link arrow forward oil" data-ng-click="angebotVm.erstelleNeuesAngebot();">Neue Tarifauskunft erstellen</a>',

                unexpected: 'Es ist ein unerwarteter Fehler aufgetreten.',
                unexpectedWithErrorId: 'Es ist ein unerwarteter Fehler aufgetreten. (Fehler-Nr. {0})',
                icapInvalidUpload: 'Die Datei enthält unerwünschte Inhalte (Viren, ausführbaren Code, etc.).',
                f5firewall: 'Es ist ein unerwarteter Fehler aufgetreten. Bitte wenden Sie sich unter Angabe der Support-ID {0} an unseren <a href="mailto:kundenservice@wgv.de?subject=Problem im Tarifrechner&body=Support-ID: {0}" target="_blank" rel="noopener">Kundenservice</a>.',
                onlineAbschlussNichtMoeglich: 'Ein Online-Abschluss ist für diese Tarifauskunft leider nicht möglich. Bitte rufen Sie uns an unter der {0} oder <a href="{1}" target="_blank" rel="noopener">schicken Sie uns eine Nachricht</a>.',
                fileUpload: 'Beim Hochladen Ihrer Dokumente ist ein Fehler aufgetreten. Es konnten nicht alle Dokumente hochgeladen werden.',
                notAllDataExists: 'Es sind nicht alle Daten vorhanden um die Aktion auszuführen.',
                hinweisAblaufdatumDoppelversicherung: 'Achtung Doppel&shy;versicherung! Bitte prüfen Sie das Ablaufdatum der Vor&shy;ver&shy;sicherung. Die Vor&shy;ver&shy;sicherung sollte vor Neu&shy;abschluss beendet sein.',
                hinweisDoppelversicherung: 'Achtung Doppel&shy;versicherung! Die Vor&shy;ver&shy;sicherung sollte vor Neu&shy;abschluss beendet sein.',
                hinweisMvpGleichAntragsteller: 'Sie dürfen nicht gleichzeitig Lebenspartner sein!. Bitte geben Sie nur in häuslicher Gemeinschaft lebenden Partner in nicht&shy;ehelicher Lebens&shy;gemein&shy;schaft an.',
                hinweisMvpEhepartnerAntragsteller: 'Ihr <strong>Ehepartner</strong> ist bedingungs&shy;gemäß mitversichert. Bitte geben Sie nur in häuslicher Gemeinschaft lebenden Partner in nicht&shy;ehelicher Lebens&shy;gemein&shy;schaft an.',
                hinweisMvpEhepartnerAntragstellerVorherigeSeite: 'Ihr <strong>Ehepartner</strong> ist bedingungs&shy;gemäß mitversichert. Bitte geben Sie nur in häuslicher Gemeinschaft lebenden Partner in nicht&shy;ehelicher Lebens&shy;gemein&shy;schaft an. Bitte korrigieren Sie den Lebenspartner auf der vorherigen Seite <strong><a class="highlight" data-ui-sref="rechner.antrag">"Antrag"</a></strong>.',
                
                angebotNeuerTarif: 'Wir bieten einen neuen Tarif an. Wollen Sie in diesen Tarif wechseln?',
                angebotNichtAenderbarAngebot: 'Sie können die Tarifauskunft fortsetzen und online abschließen oder kopieren und bearbeiten.',
                angebotNichtAenderbarAntrag: 'Die Tarifauskunft ist <strong>nicht mehr änderbar</strong>. Sie haben bereits online einen Antrag abgeschickt. Wollen Sie eine <a href="" data-ng-click="angebotVm.erstelleNeuesAngebot()">neue Tarifauskunft erstellen</a>?',
                angebotNichtAenderbarAngebotKopierenBlockiert: 'Sie können die Tarifauskunft fortsetzen und online abschließen oder eine neue Tarifauskunft erstellen.',
                angebotDruckPostEmail: 'Wir haben Ihren Auftrag entgegengenommen. Ihre Unterlagen wurden per <nobr><strong>{0}</strong></nobr> verschickt.'
            }
        };
        return {
            set: function(settings) {
                config = settings;
            },
            $get: function() {
                return config;
            }
        };
    }
})();
